import React from 'react';

import { ArrowLink } from '../Common/Links';
import { smoothScrollToRef } from '../Common/ScrollTo';
import PageSection from '../PageSections/PageSection';
import * as styles from './FooterNav.module.scss';

const FooterNav = ({ backLink = '', backLabel = '', returnRef = {} }) => {
  const onScrollCta = (e) => {
    e.preventDefault();
    smoothScrollToRef(returnRef, 'smooth');
  };

  return (
    <PageSection noPad={true} className={styles.navContainer} data-analytics-section={'footer-nav'}>
      <nav className={styles.nav}>
        <ArrowLink url={backLink} isArrowLeft={true} label={backLabel} isArrowUp={false} />
        <ArrowLink label={'Return to top'} onClick={onScrollCta} isArrowUp={true} isJumpLink={true} />
      </nav>
    </PageSection>
  );
};

export default FooterNav;
